/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".video-log-info-table th{color:#fff;background-color:#005e95;font-weight:700}"];
export { styles as styles };
